import { useTheme } from "@mui/material";
import React from "react";

/**
 * Custom time indicator for react-big-calendar: renders an arrow instead of a line.
 */
const RBCTimeIndicatorCustom: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const theme = useTheme();
  return (
    <div
      {...props}
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        height: 0,
        zIndex: 2,
        pointerEvents: "none",
        ...props.style,
      }}
    >
      {/* Arrow shape using SVG (equilateral triangle, right to left) */}
      <svg width='10' height='8.7' style={{ position: "absolute", left: -10, top: -4 }}>
        <polygon points='10,4.35 0,0 0,8.7' fill={theme.palette.secondary.main} />
      </svg>
    </div>
  );
};

export default RBCTimeIndicatorCustom;
